import styles from './homePageStyles';
import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  Modal,
  Typography,
} from '@material-ui/core';
import { TwoWeekText } from './constants';
import { useSelector } from 'react-redux';

const MobileFilterModal = ({
  filterType,
  showModal,
  handleMobileClose,
  onlyAtm,
  removeWeeks,
  noSpreads,
  onlyAtmFunction,
  removeSpreadFunction,
  removeWeeksFunction,
  removeWeeksTable2Function,
  removeWeeksTable2,
}) => {
  const { loading } = useSelector((state) => state.appReducer);
  return (
    <Modal
      style={styles.filtermodal}
      open={showModal}
      onClose={handleMobileClose}
    >
      <div style={styles.filterdivmodal}>
        Click on any Checkbox to filter the results.
        {filterType === 'table1' && (
          <div>
            <div>
              <FormControlLabel
                style={{ height: '20px', fontWeight: 'bold' }}
                control={
                  <Checkbox
                    disabled={loading}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 8.6,
                        boxShadow: '0.1px 0.1px 0.5px 0.1px',
                      },
                    }}
                    checked={onlyAtm}
                    onChange={() => onlyAtmFunction()}
                  />
                }
                label={
                  <Typography
                    style={{
                      ...styles.checkBoxText,
                      lineHeight: '10px',
                      fontSize: '0.8rem',
                    }}
                  >
                    ATM & OTM Options
                  </Typography>
                }
              />
            </div>

            <div>
              <FormControlLabel
                style={{ height: '20px', fontWeight: 'bold' }}
                control={
                  <Checkbox
                    disabled={loading}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 8.6,
                        boxShadow: '0.1px 0.1px 0.5px 0.1px',
                      },
                    }}
                    checked={noSpreads}
                    onChange={() => removeSpreadFunction()}
                  />
                }
                label={
                  <Typography
                    style={{
                      ...styles.checkBoxText,
                      lineHeight: '10px',
                    }}
                  >
                    No Spreads
                  </Typography>
                }
              />
            </div>
          </div>
        )}
        <div>
          {filterType === 'table1' ? (
            <FormControlLabel
              style={{ height: '20px', fontWeight: 'bold' }}
              control={
                <Checkbox
                  disabled={loading}
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fontSize: 8.6,
                      boxShadow: '0.1px 0.1px 0.5px 0.1px',
                    },
                  }}
                  checked={removeWeeks}
                  onChange={() => removeWeeksFunction()}
                />
              }
              label={
                <Typography
                  style={{
                    ...styles.checkBoxText,
                    lineHeight: '10px',
                  }}
                >
                  {TwoWeekText}{' '}
                </Typography>
              }
            />
          ) : (
            <FormControlLabel
              style={{ height: '20px', fontWeight: 'bold' }}
              control={
                <Checkbox
                  disabled={loading}
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fontSize: 8.6,
                      boxShadow: '0.1px 0.1px 0.5px 0.1px',
                    },
                  }}
                  checked={removeWeeksTable2}
                  onChange={() => removeWeeksTable2Function()}
                />
              }
              label={
                <Typography
                  style={{
                    ...styles.checkBoxText,
                    lineHeight: '10px',
                  }}
                >
                  {TwoWeekText}{' '}
                </Typography>
              }
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default MobileFilterModal;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/mobileFilterModal.js